// src/api_scripts/createSite.js
import { createApiClient } from "../apiClient";

const createSite = async (siteData, orgId, accessToken, setProgress) => {
  const { name } = siteData.name;

  setProgress((prev) => [
    ...prev,
    { type: 'info', message: `Attempting to create Site: "${name}"...`, timestamp: new Date().toLocaleTimeString() }
  ]);

  // API endpoint for creating a new  Site
  const relativeUri = `organization/${orgId}/site`;

  try {
    const apiClient = createApiClient(accessToken);
    const response = await apiClient.post(relativeUri, siteData);

    const newSite = response.data; // The API returns the created resource directly

    console.log("Create Site API Response Data:", newSite);

    setProgress((prev) => [
      ...prev,
      { type: 'success', message: `Successfully created Site "${name}" (ID: ${newSite.id}).`, timestamp: new Date().toLocaleTimeString() }
    ]);

    return newSite.id; // Return the created override list object (includes its ID)

  } catch (error) {
    console.error(`Error creating Site "${name}":`, error);

    let errorMessage = `Error creating Site "${name}": ${error.message || String(error)}`;

    if (error.response && error.response.data) {
      if (error.response.data.error && error.response.data.error.reason) {
        errorMessage += ` (Reason: ${error.response.data.error.reason})`;
      } else if (error.response.data.message) {
        errorMessage += ` (Detail: ${error.response.data.message})`;
      } else if (typeof error.response.data === 'string') {
        errorMessage += ` (Response: ${error.response.data})`;
      }
    }

    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw error;
  }
};

export default createSite;
